import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { Pin } from "@mui/icons-material";

import { formatVerificationCode } from "../utils/codeFormatters";

export default function VerificationCodeField({
  label = "Código para autenticação",
  required = false,
  value,
  onChange,
  error = false,
  helperText,
  length = 6,
  allowOnlyNumbers = false,
  name = "verificationCode",
  autoFocus = false,
  disabled = false,
}) {
  const inputId = `auth-${name}`;

  const handleChange = (event) => {
    onChange(
      formatVerificationCode(event.target.value, {
        allowOnlyNumbers,
        length,
      }),
    );
  };

  return (
    <Box sx={{ mb: helperText ? 1 : 1.5 }}>
      <Typography
        component="label"
        htmlFor={inputId}
        sx={(theme) => ({
          color: theme.palette.text.primary,
          display: "block",
          fontSize: theme.typography.body2.fontSize,
          fontWeight: 500,
          lineHeight: "20px",
          mb: 0.75,
        })}
      >
        {label}
        {required ? " *" : ""}
      </Typography>

      <TextField
        id={inputId}
        name={name}
        value={value}
        onChange={handleChange}
        autoComplete="one-time-code"
        autoFocus={autoFocus}
        disabled={disabled}
        error={error}
        helperText={helperText}
        fullWidth
        required={required}
        inputProps={{
          inputMode: allowOnlyNumbers ? "numeric" : "text",
          maxLength: length,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Pin fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
